// Stateroom styles for mini deck svg images

/* Below is the matrix breakdown for the stateroom meta and submeta codes

    Prefixes:
    S = Suite
    M = Mini-Suite
    B = Balcony
    D = Deluxe Balcony/Deluxe Balcony Obstructed
    O = Obstructed Balcony
    I = Inside

    Suffixes:
    A-F = standard
    1-6 = premium or deluxe
    U-Z = either obstructed or a mini-suite without a balcony

*/

var deckStyle = {
    cabinDefault: {
        fill: '#fff',
        stroke: '#000',
        'stroke-width': 1,
        'stroke-linejoin': 'round'
    },
    cabinDefaultText: {
        fill: '#999',
        font: '12px Arial',
        stroke: 'none',
        'text-anchor': 'middle'
    },
    cabinText: {
        fill: '#000'
    },
    hover: {
        fill: '#0054a0'
    },
    hoverOther: {
        fill: '#e6e6e6'
    },
    hoverText: {
        fill: '#fff'
    },
    hitArea: {
        fill: '#0f0',
        'fill-opacity': 0,
        stroke: '#0f0',
        'stroke-opacity': 0,
        'stroke-width': 1,
        'stroke-linejoin': 'round',
        cursor: 'pointer'
    },
	soldText: {
		fill: '#FF6D6D',
        font: '18px Arial',
        stroke: 'none',
        'text-anchor': 'middle'
	},
    soldIcon: {
        fill: '#f00',
        stroke: 'none'/*#ccc*/
        /*'stroke-width': 1,*/
        /*'stroke-linejoin': 'round'*/
    },
    soldIconText: {
        fill: '#fff',
        font: '10px Helvetica, Arial, sans-serif',/*10px*/
        stroke: 'none',
        'text-anchor': 'middle'
    },
    category: {
        B1: {
            fill: '#4f94aa'
        },
        B2: {
            fill: '#fbb480'
        },
        B4: {
            fill: '#df6d27'
        },
        B5: {
            fill: '#b6ca77'
        },
        BA: {
            fill: '#fff200'
        },
        BB: {
            fill: '#cc8b96'
        },
        BC: {
            fill: '#a196a5'
        },
        BD: {
            fill: '#90a79d'
        },
        BE: {
            fill: '#00aeef'
        },
        BF: {
            fill: '#00a651'
        },
        BV: {
            fill: '#905a9c'
        },
        BW: {
            fill: '#bd9a55'
        },
        BX: {
            fill: '#dc9317'
        },
        BY: {
            fill: '#b1b3c0'
        },
        BZ: {
            fill: '#ffd881'
        },
        D4: {
            fill: '#479fc0'
        },
        DA: {
            fill: '#7eba94'
        },
        DB: {
            fill: '#8d87c1'
        },
        DC: {
            fill: '#fcc290'
        },
        DD: {
            fill: '#b5d5f0'
        },
        DE: {
            fill: '#e5a524'
        },
        DF: {
            fill: '#efabcc'
        },
        DV: {
            fill: '#e57c5f'
        },
        DW: {
            fill: '#80c342'
        },
        DZ: {
            fill: '#aad37e'
        },
        IA: {
            fill: '#dce2ed'
        },
        IB: {
            fill: '#ffcb05'
        },
        IC: {
            fill: '#5fa499'
        },
        ID: {
            fill: '#efa492'
        },
        IE: {
            fill: '#b6b2d8'
        },
        IF: {
            fill: '#98c4e9'
        },
        M4: {
            fill: '#b1b3b6'
        },
        M6: {
            fill: '#b4b76e'
        },
        MA: {
            fill: '#f287b7'
        },
        MB: {
            fill: '#ffd881'
        },
        MC: {
            fill: '#7a9cd1'
        },
        MD: {
            fill: '#b38319'
        },
        ME: {
            fill: '#75c7b9'
        },
        MF: {
            fill: '#e6e7e8'
        },
        MG: {
            fill: '#fcc8a8'
        },
        MY: {
            fill: '#faa85f'
        },
        O3: {
            fill: '#9ec2a6'
        },
        O4: {
            fill: '#af9fb9'
        },
        O5: {
            fill: '#d1b575'
        },
        O6: {
            fill: '#f7941e'
        },
        OB: {
            fill: '#7abca2'
        },
        OC: {
            fill: '#cc8b96'
        },
        OD: {
            fill: '#d7c5dc'
        },
        OE: {
            fill: '#fedbb4'
        },
        OF: {
            fill: '#ebcb00'
        },
        OV: {
            fill: '#caa8ad'
        },
        OW: {
            fill: '#a2bdc3'
        },
        OY: {
            fill: '#d7799b'
        },
        OZ: {
            fill: '#f15f43'
        },
        S1: {
            fill: '#f37321'
        },
        S2: {
            fill: '#bc9ac8'
        },
        S3: {
            fill: '#c74b9b'
        },
        S4: {
            fill: '#f7e6c0'
        },
        S5: {
            fill: '#f04934'
        },
        S6: {
            fill: '#83b6c2'
        },
        S7: {
            fill: '#9b88b1'
        },
        S8: {
            fill: '#fccebb'
        }
    }
}